<template>
  <div>
    <div class="friend_link">
      Powered By <a href="https://v2.cn.vuejs.org/" style="color:skyblue;">Vue2.x</a>
    </div>
</div>
</template>
<script>
export default {
    name:'foot'
}
</script>

<style scoped>
.friend_link{
  text-align: center;
}
</style>